module.exports = __webpack_public_path__ + "public/img/pingtaikehushuju.269b1496.png";